import type { ComponentType } from 'react';

import { isSandboxEnvironment } from './sandbox/isSandboxEnvironment';

const withSandbox = <T extends object>(Component: ComponentType<T>) => {
  const SandboxComponent = (props: T) =>
    isSandboxEnvironment() ? <Component {...props} /> : null;

  SandboxComponent.displayName = `withSandbox(${
    Component.displayName || Component.name || 'Component'
  })`;

  return SandboxComponent;
};

export { withSandbox };
